import { getTroubleshootingState } from './troubleshooting-state';
export const getStepName = (state) => getTroubleshootingState(state).stepName;
